import { Modal } from "~/jose_modern/modal.js";

export function initNameModal() {
  document.addEventListener("click", (e) => {
    if (e.target.closest("#recipe-name-edit-link") || e.target.closest("#recipe-title")) {
      e.preventDefault();
      Modal.show("#recipe-name-modal");
    }

    if (e.target.closest("#recipe-display-name-reset")) {
      document.querySelector("#recipe-display-name-input").value = "";
    }
  });

  document.addEventListener("modal:close", (e) => {
    if (e.target.closest("#recipe-name-modal")) {
      e.target.closest("#recipe-name-modal").querySelector("form")?.reset();
    }
  });
}
